import { useLayoutEffect } from 'react';
import { resetAppScrollRoot } from '../utils/lockAppScroll';

/**
 * On standalone change mount, pin the App outlet back to the top so a previous
 * scroll offset cannot leave the user in empty space after remount/reload.
 */
export function useResetAppScrollOnMount(enabled: boolean) {
    useLayoutEffect(() => {
        if (!enabled)
            return undefined;

        resetAppScrollRoot();
        return undefined;
    }, [enabled]);
}
